/**
 * Google Tag Manager initialization utility
 */

import { debugLog } from './debug';

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

/**
 * Initialize Google Tag Manager
 * @param gtmId - The GTM container ID (e.g., 'GTM-XXXXXXX')
 */
export function initializeGTM(gtmId: string): void {
  if (!gtmId || gtmId === 'undefined') {
    console.warn('[GTM] Container ID not provided, skipping initialization');
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  // Inject GTM script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  // Inject noscript iframe
  const noscriptPlaceholder = document.getElementById(
    'gtm-noscript-placeholder'
  );
  if (noscriptPlaceholder) {
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    noscriptPlaceholder.appendChild(iframe);
  }

  debugLog(`[GTM] Initialized with container ID: ${gtmId}`);
}

/**
 * Push an event to the GTM data layer
 * @param event - The event name
 * @param data - Additional event data
 */
export function pushGTMEvent(
  event: string,
  data?: Record<string, unknown>
): void {
  if (window.dataLayer) {
    window.dataLayer.push({
      event,
      ...data,
    });
  }
}
